
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hard/atoms/us/glove",
      function () {
        return require("private-next-pages/hard/atoms/us/glove/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hard/atoms/us/glove"])
      });
    }
  